import { Box, Typography } from '@mui/material';

const Footer = () => {
    return (
        <Box p={1} sx={{textAlign: 'center', backgroundColor: '#f5f5f5'}}>
            <Typography variant="caption" sx={{ display: {xs: 'none', sm: 'block'}}}>
                The Digital BRSR is designed by Ernst & Young LLP &nbsp; | &nbsp; Data and information is provided by Mahindra & Mahindra Ltd.
            </Typography>
            <Typography variant="caption" sx={{ fontSize: '11px', display: {xs: 'block', sm: 'none'}}}>
                The Digital BRSR is designed by Ernst & Young LLP 
                <br/>
                Data and information is provided by Mahindra & Mahindra Ltd.
            </Typography>
        </Box>
    );
}
 
export default Footer;